import { ReactComponent as SvgBacterialDna } from 'assets/svg/bacterial-dna.svg';
import { ReactComponent as SvgPlasmid } from 'assets/svg/plasmid.svg';
import OperonBlock from 'components/OperonBlock';
import OperonDraggable from 'components/OperonDraggable';
import OperonExpression from 'components/OperonExpression';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { Button } from 'react-bulma-components';
import { IOperon } from 'stores/models/LacOperon';
import SectionHeader from './SectionHeader';

interface IProps {
  operonBacterial: IOperon;
  operonPlasmid: IOperon;
}

class View extends Component<IProps> {
  private reset = () => {
    const { operonBacterial, operonPlasmid } = this.props;
    operonBacterial.reset();
    operonPlasmid?.reset();
  };

  render() {
    const { operonBacterial, operonPlasmid } = this.props;
    const hasDefaultGenesBacterial = operonBacterial.hasDefaultGenes.get();
    const hasDefaultGenesPlasmid = operonPlasmid.hasDefaultGenes.get();
    const isDisabled = hasDefaultGenesBacterial && hasDefaultGenesPlasmid;

    return (
      <div className='card has-border-1 is-shadowless mb-5 p-5'>
        <SectionHeader isDisabled={isDisabled} step={1} onReset={this.reset}>
          <span className='has-text-grey is-size-7'>
            <span className='has-text-weight-semibold'>
              <span className='is-italic'>Toggle</span> genes to modify an
              operon then <span className='is-italic'>drag</span> the
              corresponding DNA molecule
            </span>
            <br />
            <span className='has-text-grey-light'>
              All genes are toggleable except the promoter
            </span>
          </span>
        </SectionHeader>

        <div className='is-flex-centered'>
          <div className='mr-5'>
            <OperonDraggable model={operonBacterial}>
              <SvgBacterialDna />
            </OperonDraggable>
            <div className='is-size-7 has-text-centered mt-2'>
              {operonBacterial.info.label}
            </div>
          </div>
          <div className='is-flex-grow-1'>
            <OperonBlock model={operonBacterial} />
            <div className='is-flex-centered is-justify-content-space-between mt-2'>
              <div className='is-flex-centered'>
                <OperonExpression model={operonBacterial} />
                {hasDefaultGenesBacterial && (
                  <span className='is-size-7 is-italic has-text-grey-light ml-3'>
                    Default
                  </span>
                )}
              </div>
              <Button
                disabled={hasDefaultGenesBacterial}
                size='small'
                onClick={operonBacterial.reset}
              >
                Reset
              </Button>
            </div>
          </div>
        </div>

        <hr className='is-divider-2 has-background-transparent' />

        <div className='is-flex-centered'>
          <div className='mr-5'>
            <OperonDraggable model={operonPlasmid}>
              <SvgPlasmid />
            </OperonDraggable>
            <div className='is-size-7 has-text-centered mt-2'>
              {operonPlasmid.info.label}
            </div>
          </div>
          <div className='is-flex-grow-1'>
            <OperonBlock model={operonPlasmid} />
            <div className='is-flex is-justify-content-space-between mt-2'>
              <div className='is-flex-centered'>
                <OperonExpression model={operonPlasmid} />
                {hasDefaultGenesPlasmid && (
                  <span className='is-size-7 is-italic has-text-grey-light ml-3'>
                    Default
                  </span>
                )}
              </div>
              <Button
                disabled={hasDefaultGenesPlasmid}
                size='small'
                onClick={operonPlasmid.reset}
              >
                Reset
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const Section1 = observer(View);
export default Section1;
